import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Link } from "react-router-dom";

import { Card, Button } from "react-bootstrap";

import Icon from "components/Icons/Icon";
import ProgressBar from "components/Enterprise/Reports/Common/ProgressBar";

import {
  loadSitesOnTestCountStart,
  loadSitesOnTestCountRefreshStart,
  loadSitesOnTestCountRefreshCancel,
  loadSitesOnTestRefreshStart,
  loadSitesOnTestRefreshCancel,
  clearSitesOnTest,
} from "services/redux/actions/sitesOnTest";

import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";
import { getGroupFromRoute } from "services/redux/selectors/groups";

import PutSiteOnTestModal from "./PutSiteOnTestModal";

import DataTable from "./DataTable";

import "../AlarmResponse.scss";

function SitesOnTest(props) {
  const dispatch = useDispatch();

  const [putSiteOnTestModalShow, setPutSiteOnTestModalShow] = useState(false);

  const enterprise = useSelector(getEnterpriseFromRoute);
  const group = useSelector(getGroupFromRoute);
  const lastRefresh = useSelector(state => state.sitesOnTest.lastRefresh);
  const nextRefresh = useSelector(state => state.sitesOnTest.nextRefresh);
  const sitesOnTestCount = useSelector(state => state.sitesOnTest.sitesOnTestCount);
  const warningSiteOnTest = useSelector(state => state.sitesOnTest.warningSiteOnTest);

  const enterpriseId = enterprise.id;
  const groupId = (group && group.id) || enterprise.root_group_id;

  useEffect(() => {
    dispatch(
      loadSitesOnTestRefreshStart({ 
        enterprise_id: enterpriseId,
        group_id: groupId,
      })
    );

    dispatch(
      loadSitesOnTestCountStart({ 
        enterprise_id: enterpriseId,
        group_id: groupId, 
      })
    );

    dispatch(
      loadSitesOnTestCountRefreshStart({ 
        enterprise_id: enterpriseId,
        group_id: groupId, 
      })
    );

    return () => {
      // run on unmount
      dispatch(
        loadSitesOnTestRefreshCancel()
      );

      dispatch(
        loadSitesOnTestCountRefreshCancel()
      );

      dispatch(
        clearSitesOnTest()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const putSiteOnTestModalClose = () => {
    setPutSiteOnTestModalShow(false);
  };

  return (
    <div>
      <div className="d-flex justify-content-end">
        <div>
          <Link
            to={{
              pathname: `/enterprise/${enterpriseId}/${groupId}/alarms`,
            }}
          >
            <div>
              <Button
                variant=""
                className="pe-tab-button mr-1"
              >
                Priority Events
              </Button> 
            </div>
          </Link>
        </div>
        <div>
          <Button
            variant="active"
            className="pe-tab-button"
          >
            <span className="mr-2">Active Tests</span>
            <span>{sitesOnTestCount}</span>
            {
              warningSiteOnTest && warningSiteOnTest > 0
                ? <span className="ml-2" style={{ borderLeft: "2px solid" }}>
                    <Icon className="ml-2 mr-2 fas fa-clock" />
                    <span>{warningSiteOnTest}</span>
                  </span>
                : ""
            }
          </Button> 
        </div>
      </div>
      <Card>
        <div className="mb-2 d-flex justify-content-between px-2 pt-2">
          <div className="d-flex justify-content-start flex-grow-1"  style={{ marginBottom: "8px", minHeight: "44px" }}>
            <div
              style={{ fontSize: "12px" }}
              className="text-center">
              <ProgressBar
                placement="right"
                nextRefresh={nextRefresh}
                lastRefresh={lastRefresh}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            <Button
              style={{backgroundColor: "#8e44ad", border: "1px solid #8e44ad"}}
              onClick={() => { setPutSiteOnTestModalShow(true) }}
            >Put Site on Test</Button>
          </div>
        </div>
        <div>
          <DataTable/>
        </div>
        <PutSiteOnTestModal 
          show={putSiteOnTestModalShow} 
          onHide={putSiteOnTestModalClose}
        />
      </Card>
    </div>
  );
}

export default SitesOnTest;